// en/英文 ko/韩语
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en/translation.json";
import zhHKTranslation from "./zh-HK/translation.json";
import zhTranslation from "./zh-CN/translation.json";
import koTranslation from "./ko/translation.json";
import jaTranslation from "./ja/translation.json";
import { useLocalStorage } from "@/util/Storage";

// const keys: Array<keyof typeof enTranslation> = Object.keys(
// 	enTranslation
// ) as Array<keyof typeof enTranslation>; // 获取所有的键

// const enValues = keys.map((key) => koTranslation[key]);
// console.log(enValues);

export type Language = { name: string; val: string };
export const interfaceLanguage = ["ko", "zhHK", "en", "zh", "ja"]; //接口多语言的顺序
export const supportedLanguages: Language[] = [
	{ name: "English", val: "en" },
	{ name: "한국인", val: "ko" },
	{ name: "中文简体", val: "zh" },
	{ name: "中文繁体", val: "zhHK" },
	{ name: "日本語", val: "ja" },
];

export function getBrowserLanguage() {
	let browserLanguage = navigator.language.replace("-", "");
	if (["zh", "zhCN"].includes(browserLanguage)) {
		browserLanguage = "zh";
	} else if (["zhTW", "zhHK"].includes(browserLanguage)) {
		browserLanguage = "zhHK";
	}
	const savedLanguage = useLocalStorage.get("Language");
	let isChinese = supportedLanguages.find(
		(lang) => lang.val === browserLanguage
	);
	const language = savedLanguage || isChinese?.val || "en";
	return language;
}

export const changeLanguage = (val: string) => {
	useLocalStorage.set("Language", val);
	i18n.changeLanguage(val);
};

export function translateLanguage(
	inputString: string,
	language: string
): string {
	// 将 inputString 解析为对象
	const parsedInput = JSON.parse(inputString);
	// 获取对应语言的翻译
	return parsedInput[language] || parsedInput["en"]; // 默认返回英文翻译
}
export const defaultLang = getBrowserLanguage();
useLocalStorage.set("Language", defaultLang);

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: enTranslation },
		ko: { translation: koTranslation },
		zh: { translation: zhTranslation },
		zhHK: { translation: zhHKTranslation },
		ja: { translation: jaTranslation },
	},
	lng: defaultLang,
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
